import {MOON_650} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const Panel = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;
Panel.displayName = 'S.Panel';

export const Page = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
`;
Page.displayName = 'S.Page';

export const ColumnSpacer = styled.div`
  height: 71px;
`;
ColumnSpacer.displayName = 'S.ColumnSpacer';

export const PanelRow = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: flex-start;
`;
PanelRow.displayName = 'S.PanelRow';

export const PanelColumn = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-right: 60px;
`;
PanelColumn.displayName = 'S.PanelColumn';

export const Heading = styled.div`
  font-weight: 400;
  font-size: 24px;
  line-height: 30px;
  margin-bottom: 24px;
`;
Heading.displayName = 'S.Heading';

export const Message = styled.div`
  font-weight: 400;
  max-width: 750px;
  font-size: 20px;
  line-height: 28px;
  margin-bottom: 18px;
  color: ${MOON_650};
`;
Message.displayName = 'S.Message';
